import React from 'react';
import { Modal, Button } from '../ui-kit';
import { Provider } from 'react-redux';
import store from '../../state';
import PersonnelTransferForm from './PersonnelTransferForm';

class PersonnelTransferModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isSaving: false };
  }

  registerSaveCallback = callback => (this.saveCallback = callback);

  save = () => {
    if (!this.saveCallback) return;
    this.setState({ isSaving: true });
    this.saveCallback().then(({ success, id }) => {
      if (success) {
        // add the created_id param so the new transfer will be highlighted in
        // the list of transfers
        const url = new URL(location.href);
        const searchParams = url.searchParams;
        searchParams.set('created_id', id);
        url.search = searchParams.toString();
        location.href = url.toString();
      } else {
        this.setState({ isSaving: false });
      }
    });
  };

  render() {
    return (
      <Modal size="lg" show={true} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{I18n.t('schedules.exchanges.personnel_transfer.modal_title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflowY: 'visible' }}>
          <Provider store={store}>
            <PersonnelTransferForm {...this.props} registerSaveCallback={this.registerSaveCallback} />
          </Provider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.onHide}>
            {I18n.t('cancel')}
          </Button>
          <Button onClick={this.save} disabled={this.state.isSaving} variant="primary">
            {this.state.isSaving ? I18n.t('saving') : I18n.t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default PersonnelTransferModal;
